"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var __1 = require("../../../..");
var useBoolean_1 = __importDefault(require("../../../../hooks/useBoolean"));
var Button_1 = __importDefault(require("../../../Button/Button"));
var LinkButton_1 = __importDefault(require("../../../Button/LinkButton"));
var Label_1 = require("../../../Label");
var Message_1 = require("../../../Message");
var Padder_1 = require("../../../Padder");
var Popup_1 = __importDefault(require("../../../Popup/Popup"));
var LeftPanelHeader_1 = __importDefault(require("../LeftPanelHeader"));
var ModalButtonsWrap_1 = __importDefault(require("../ModalButtonsWrap"));
var NoDataLabel_1 = __importDefault(require("../NoDataLabel"));
var PopupHeader_1 = __importDefault(require("../PopupHeader"));
var Utils_1 = require("../Utils");
var DetailPozastaveniCinnosti_1 = __importDefault(require("./DetailPozastaveniCinnosti"));
var PridatPozastaveniCinnosti_1 = __importDefault(require("./PridatPozastaveniCinnosti"));
var UpravitPozastaveniCinnosti_1 = __importDefault(require("./UpravitPozastaveniCinnosti"));
var Pozastaveni = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  padding: 2rem;\n\n  div:first-of-type {\n    margin-bottom: 20px;\n  }\n"], ["\n  padding: 2rem;\n\n  div:first-of-type {\n    margin-bottom: 20px;\n  }\n"])));
var StyledLabel = styled_components_1.default(Label_1.Label)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: #1ca854;\n  padding: 8px 10px;\n  color: #ffffff;\n  border-radius: 3px;\n  font-size: 12px;\n  line-height: 14px;\n  font-weight: bold;\n  margin-bottom: 10px;\n"], ["\n  background-color: #1ca854;\n  padding: 8px 10px;\n  color: #ffffff;\n  border-radius: 3px;\n  font-size: 12px;\n  line-height: 14px;\n  font-weight: bold;\n  margin-bottom: 10px;\n"])));
var ModalGreenLabel = styled_components_1.default(StyledLabel)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  font-size: 14px;\n  padding: 10px 12px;\n  margin-bottom: 0 !important;\n"], ["\n  font-size: 14px;\n  padding: 10px 12px;\n  margin-bottom: 0 !important;\n"])));
var ErrorLabel = styled_components_1.default(StyledLabel)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  background-color: #fe505d;\n"], ["\n  background-color: #fe505d;\n"])));
var SMessage = styled_components_1.default(Message_1.Message)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-bottom: 24px;\n"], ["\n  margin-bottom: 24px;\n"])));
var PopupChildren = styled_components_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  overflow: auto;\n  max-height: 430px;\n"], ["\n  overflow: auto;\n  max-height: 430px;\n"])));
var PozastaveniCinnosti = function (_a) {
    var pozastaveniCinnosti = _a.pozastaveniCinnosti, idSubjekt = _a.idSubjekt, refetch = _a.refetch, znalecValues = _a.znalecValues, tlumocnikValues = _a.tlumocnikValues, isKancelar = _a.isKancelar, aktivniZanik = _a.aktivniZanik;
    var isOpen = useBoolean_1.default(false);
    var isAddNewOpen = useBoolean_1.default(false);
    var isEditOpen = useBoolean_1.default(false);
    var _b = react_1.useState(0), idToEdit = _b[0], setIdToEdit = _b[1];
    var apiUrl = __1.useConfig().apiUrl;
    var iszrUrl = __1.useConfig().iszrUrl;
    var deleteJSON = __1.useDeleteJSON(apiUrl + "/PozastaveniOpravneni/Delete");
    var zmenOsobu = __1.usePostJSON(iszrUrl + "/ZmenOsobu");
    var _c = react_1.useState(), deleteMessage = _c[0], setDeleteMessage = _c[1];
    var handleAddNew = function () {
        isAddNewOpen.toggle();
        setDeleteMessage(undefined);
    };
    var handleEdit = function (id) {
        setIdToEdit(id);
        isEditOpen.toggle();
        setDeleteMessage(undefined);
    };
    var handleClose = function () {
        isOpen.setFalse();
        isAddNewOpen.setFalse();
        isEditOpen.setFalse();
        setIdToEdit(0);
        setDeleteMessage(undefined);
    };
    var handleSmazat = function (id, dMessage, aktivniPozastaveni, uzivatel) { return __awaiter(void 0, void 0, void 0, function () {
        var rosMessage, response, zmenOsobuValues, aktualizovatPozastaveni, zanikAPreruseni, rosResponse, e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 7, , 8]);
                    rosMessage = void 0;
                    return [4 /*yield*/, deleteJSON([id])];
                case 1:
                    response = _a.sent();
                    if (!__1.isRight(response)) return [3 /*break*/, 6];
                    if (!refetch) return [3 /*break*/, 3];
                    return [4 /*yield*/, refetch()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    if (!(aktivniPozastaveni && !isKancelar)) return [3 /*break*/, 5];
                    zmenOsobuValues = void 0;
                    if (!(znalecValues || tlumocnikValues)) return [3 /*break*/, 5];
                    aktualizovatPozastaveni = response.value.aktualizovatPozastaveni;
                    if (!aktualizovatPozastaveni) return [3 /*break*/, 5];
                    zanikAPreruseni = {
                        pozastaveniOpravneniBool: response.value.aktivniPozastaveni,
                        uzivatel: uzivatel,
                    };
                    if (znalecValues) {
                        zmenOsobuValues = Utils_1.znalecValuesForROS(znalecValues, zanikAPreruseni);
                    }
                    if (tlumocnikValues) {
                        zmenOsobuValues = Utils_1.tlumocnikValuesForROS(tlumocnikValues, zanikAPreruseni);
                    }
                    return [4 /*yield*/, zmenOsobu(zmenOsobuValues)];
                case 4:
                    rosResponse = _a.sent();
                    if (__1.isRight(rosResponse))
                        rosMessage = { message: 'Referenční údaje byly úspěšně aktualizovány v ROS.', type: 'success' };
                    else
                        rosMessage = { message: rosResponse.value.message, type: 'error' };
                    _a.label = 5;
                case 5:
                    setDeleteMessage([rosMessage, { message: dMessage, type: 'success' }]);
                    _a.label = 6;
                case 6: return [2 /*return*/, response];
                case 7:
                    e_1 = _a.sent();
                    return [2 /*return*/, __1.Left(e_1.message)];
                case 8: return [2 /*return*/];
            }
        });
    }); };
    var getItem = function () {
        return pozastaveniCinnosti === null || pozastaveniCinnosti === void 0 ? void 0 : pozastaveniCinnosti.find(function (x) { return x.id === idToEdit; });
    };
    var dateMinusOne = Date.now() - 3600 * 1000 * 24;
    var aktivniPozastaveni = (pozastaveniCinnosti === null || pozastaveniCinnosti === void 0 ? void 0 : pozastaveniCinnosti.find(function (item) {
        return (item.datumOd != null && item.datumDo === null && Date.now() >= Date.parse(item.datumOd)) ||
            (item.datumOd != null && item.datumDo != null && Date.parse(item.datumDo) >= dateMinusOne && Date.now() >= Date.parse(item.datumOd));
    })) != null;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Pozastaveni, null,
            react_1.default.createElement(LeftPanelHeader_1.default, null, "Pozastaven\u00ED \u010Dinnosti"),
            !aktivniZanik && !aktivniPozastaveni && pozastaveniCinnosti && pozastaveniCinnosti.length > 0 && react_1.default.createElement(StyledLabel, { type: "green" }, "\u010Cinnost je Aktivn\u00ED"),
            pozastaveniCinnosti && pozastaveniCinnosti.length > 0 ? (react_1.default.createElement(react_1.default.Fragment, null,
                !aktivniZanik && aktivniPozastaveni && react_1.default.createElement(ErrorLabel, { type: "error" }, "\u010Cinnost je pozastavena"),
                pozastaveniCinnosti.map(function (item) { return (react_1.default.createElement(DetailPozastaveniCinnosti_1.default, { tlumocnikValues: tlumocnikValues, znalecValues: znalecValues, isKancelar: isKancelar, key: item.id, pozastaveniCinnosti: item, handleEdit: handleEdit, refetch: refetch, handleSmazat: handleSmazat })); }))) : (react_1.default.createElement(NoDataLabel_1.default, null)),
            idSubjekt && (react_1.default.createElement(LinkButton_1.default, { type: "button", className: "button", onClick: isOpen.toggle }, "Spravovat"))),
        react_1.default.createElement(Popup_1.default, { open: isOpen.value, onClose: handleClose },
            isAddNewOpen.value && (react_1.default.createElement(PridatPozastaveniCinnosti_1.default, { tlumocnikValues: tlumocnikValues, znalecValues: znalecValues, isKancelar: isKancelar, idSubjekt: idSubjekt !== null && idSubjekt !== void 0 ? idSubjekt : 0, handleClose: isOpen.setFalse, refetch: refetch })),
            isEditOpen.value && (react_1.default.createElement(UpravitPozastaveniCinnosti_1.default, { tlumocnikValues: tlumocnikValues, znalecValues: znalecValues, isKancelar: isKancelar, initialValues: getItem(), idSubjekt: idSubjekt !== null && idSubjekt !== void 0 ? idSubjekt : 0, handleClose: isOpen.setFalse, refetch: refetch })),
            !isEditOpen.value && !isAddNewOpen.value && (react_1.default.createElement(Padder_1.Padder, null,
                react_1.default.createElement(PopupHeader_1.default, null, "Pozastaven\u00ED \u010Dinnosti"),
                (deleteMessage || [])
                    .filter(function (d) { return d; })
                    .map(function (d, index) {
                    return (react_1.default.createElement(SMessage, { type: d.type, onClose: function () {
                            setDeleteMessage(deleteMessage.filter(function (m) { return m !== deleteMessage[index]; }));
                        } }, d.message));
                }),
                react_1.default.createElement(PopupChildren, null,
                    !aktivniZanik && !aktivniPozastaveni && pozastaveniCinnosti && pozastaveniCinnosti.length > 0 && react_1.default.createElement(ModalGreenLabel, { type: "green" }, "\u010Cinnost je Aktivn\u00ED"),
                    pozastaveniCinnosti &&
                        pozastaveniCinnosti.length > 0 &&
                        pozastaveniCinnosti.map(function (item) { return (react_1.default.createElement(DetailPozastaveniCinnosti_1.default, { tlumocnikValues: tlumocnikValues, znalecValues: znalecValues, isKancelar: isKancelar, key: item.id, pozastaveniCinnosti: item, isModal: true, handleEdit: handleEdit, idSubjekt: idSubjekt !== null && idSubjekt !== void 0 ? idSubjekt : 0, refetch: refetch, handleSmazat: handleSmazat })); })),
                !aktivniPozastaveni && (react_1.default.createElement(ModalButtonsWrap_1.default, null,
                    react_1.default.createElement(Button_1.default, { type: "button", primary: true, onClick: handleAddNew, name: "Pozastavit" }, "Pozastavit \u010Dinnost"))))))));
};
PozastaveniCinnosti.defaultProps = {
    pozastaveniCinnosti: undefined,
    idSubjekt: undefined,
    refetch: undefined,
    znalecValues: undefined,
    tlumocnikValues: undefined,
    isKancelar: undefined,
    aktivniZanik: undefined,
};
exports.default = PozastaveniCinnosti;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6;
